module.exports = __webpack_public_path__ + "img/1.3-zh.4a212573.png";